var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 8.75008V5.66675C14.6663 4.26662 14.6663 3.56655 14.3939 3.03177C14.1542 2.56137 13.7717 2.17892 13.3013 1.93923C12.7665 1.66675 12.0665 1.66675 10.6663 1.66675H5.33301C3.93288 1.66675 3.23281 1.66675 2.69803 1.93923C2.22763 2.17892 1.84517 2.56137 1.60549 3.03177C1.33301 3.56655 1.33301 4.26662 1.33301 5.66675V14.3334C1.33301 15.7335 1.33301 16.4336 1.60549 16.9684C1.84517 17.4388 2.22763 17.8212 2.69803 18.0609C3.23281 18.3334 3.93288 18.3334 5.33301 18.3334H7.99967M9.66634 9.16675H4.66634M6.33301 12.5001H4.66634M11.333 5.83341H4.66634M12.9997 17.5001V12.5001M10.4997 15.0001H15.4997",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.5da98b921d337ac7b8e8e8a9cb52e1fd.svg";
export { ForwardRef as ReactComponent };